<template>
    <div class="system-institutions-management">
        <!-- <div class="title_container">
      机构管理
        </div>-->
        <div class="system-institutions-content">
            <div class="system-tree" :style="{ width: treewidth }">
                <!-- <el-scrollbar style="height:100%"> -->
                <institutions_tree
                    @changeWidth="doChangeTableWidth"
                ></institutions_tree>
                <!-- </el-scrollbar> -->
            </div>
            <div class="system-table" :style="{ width: width }">
                <institutions_table :treeId="treeId"></institutions_table>
            </div>
        </div>
    </div>
</template>
<script>
import institutions_table from "./comons/institutions_table";
import institutions_tree from "./comons/institutions_tree";
export default {
    components: {
        institutions_tree: institutions_tree,
        institutions_table: institutions_table
    },
    data() {
        return {
            width: "calc(100% - 370px)",
            treewidth: "280px"
        };
    },
    methods: {
        doChangeTableWidth(data) {
            if (data.width == 1) {
                this.width = "calc(100% - 370px)";
                this.treewidth = "280px";
            } else {
                this.width = "calc(100% - 61px)";
                this.treewidth = "36px";
            }
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="scss">
.system-institutions-management {
    width: 100%;
    // background: rgba(6, 41, 98, 0.8);
    height: 100%;
    display: flex;
    flex-direction: column;
    .title_container {
        width: 100%;
        text-indent: 20px;
        text-align: left;
        font-size: 16px;
        line-height: 40px;
        height: 40px;
        color: #484848;
        border-bottom: 1px solid #efefef;
    }
    .system-institutions-content {
        flex: 1;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        width: 100%;
        height: 100%;
        .system-tree {
            width: px2Rem(280px);
            height: 100%;
            //   padding-right: 20px;
            margin: 0 30px;
            // border-right: 1px solid rgb(179, 202, 222);
            overflow: hidden;
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
        .system-table {
            flex: 1;
            height: 100%;
            // overflow-y: auto;
        }
    }
    .btnContainer {
        text-align: right;
        margin: 20px;
    }
    .tableContainer {
        width: 100%;
        el-table {
            width: 100%;
        }
    }
    .color_green {
        color: #009788;
    }
    .color_red {
        color: red;
    }
    .color_unred {
        color: #8c3e27;
    }
}
</style>
